import lodashMerge from 'lodash/merge';

export function merge<T extends object>(...objects: T[]): T {
  let result = {} as T;
  for (const object of objects) {
    result = lodashMerge(result, object);
  }
  return result;
}